import queryString from "query-string";
import * as appConstants from "../config/constants";

export const FRAME_NAME = "authframe";

export const SIGNIN = "SIGNIN";

export const REGISTER1 = "REGISTER1";
export const REGISTER2 = "REGISTER2";
export const REGISTER3 = "REGISTER3";

export const FORGOTPASSWORD1 = "FORGOTPASSWORD1";
export const FORGOTPASSWORD2 = "FORGOTPASSWORD2";
export const FORGOTPASSWORD3 = "FORGOTPASSWORD3";
export const FORGOTPASSWORD4 = "FORGOTPASSWORD4";

export let CLIENT_ID;
switch (process.env.ENV) {
  case "production":
    CLIENT_ID = "platform-site-prod";
    break;
  default:
    // staging and development use the same client id
    CLIENT_ID = "platform-site";
}

// Build auth URL as query string
const authObj = {
  client_id: CLIENT_ID,
  redirect_uri: encodeURI(`${appConstants.FRONTEND_ROOT}/authorize`),
  scope: "read write",
  response_type: "token",
  state: Date.now(),
};

export const AUTH_URL = `${
  appConstants.BACKEND_ROOT
}/o/authorize/?${queryString.stringify(authObj)}`;

export const LOGOUT_URL = `${appConstants.BACKEND_ROOT}/logout/`;

export const INDUSTRIES = [
  "Aerospace / Defense",
  "Agency",
  "Agriculture",
  "Architecture / Engineering / Construction",
  "Banking / Financial Services / Insurance",
  "Education",
  "Energy / Environment / Utilities",
  "Government",
  "Healthcare / Pharmaceuticals",
  "Hospitality",
  "Manufacturing",
  "Media / Entertainment",
  "Not For Profit",
  "Other",
  "Professional Services",
  "Retail / Consumer",
  "Technology / Telecommunications",
];
